import { getStoredValue, isStoredRole } from "./storageUtils";

export function isAdmin() {
  return isStoredRole("Super Admin");
}

export function currentUserId() {
  return getStoredValue("userId");
}
export function currentUserToken() {
  return getStoredValue("token", "authToken");
}

export function currentUserPlannerToken() {
  return getStoredValue("planner_access_token");
}

export const getAPIBaseUrl = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/api`;

  return window.location.hostname === "localhost"
    ? "https://sofmen.taskboard.sofmen.com/api"
    : url;
};

export const getAPIBaseUrlVersion1 = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1`;

  return window.location.hostname === "localhost"
    ? "https://sofmen.taskboard.sofmen.com/api/v1"
    : url;
};
